import React, { useState } from 'react';
import './styles.css';

const PhotoGalleryView = ({ data }) => {
  const { title, titleAlignment = 'center', images = [] } = data;
  // console.log('PhotoGallery data:', data); // Log dei dati completi
  // console.log('PhotoGallery images:', images); // Log delle immagini

  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const imagesPerRow = 4;
  const totalPages = Math.ceil(images.length / imagesPerRow);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : totalPages - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < totalPages - 1 ? prev + 1 : 0));
  };

  const handleImageClick = (index) => {
    setSelectedImage(index);
  };

  const handleClose = () => {
    setSelectedImage(null);
  };

  const handlePrevLarge = () => {
    setSelectedImage((prev) => (prev > 0 ? prev - 1 : images.length - 1));
  };

  const handleNextLarge = () => {
    setSelectedImage((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  };

  const startIndex = currentIndex * imagesPerRow;
  const visibleImages = images.slice(startIndex, startIndex + imagesPerRow);

  // Funzione per ottenere l’URL base64 dell’immagine
  const getImageUrl = (item) => {
    if (!item || !item.image || !item.image.data) return '';
    const { 'content-type': contentType, data } = item.image;
    const base64Url = `data:${contentType};base64,${data}`;
    // console.log('Generated image URL:', base64Url); // Log dell’URL generato
    return base64Url;
  };

  return (
    <div className="photo-gallery-block">
      {title && (
        <h2 className={`gallery-title ${titleAlignment}`}>{title}</h2>
      )}
      {images.length > 0 && (
        <div className="gallery-wrapper">
          {images.length > imagesPerRow && (
            <button className="gallery-arrow prev" onClick={handlePrev}>
              ◀
            </button>
          )}
          <div className="gallery-images">
            {visibleImages.map((item, index) => (
              <img
                key={index}
                src={getImageUrl(item)}
                alt={item.altText || item.image?.filename || 'Gallery Image'} // Usa altText
                className="gallery-image"
                onClick={() => handleImageClick(startIndex + index)}
              />
            ))}
          </div>
          {images.length > imagesPerRow && (
            <button className="gallery-arrow next" onClick={handleNext}>
              ▶
            </button>
          )}
        </div>
      )}
      {selectedImage !== null && (
        <div className="gallery-modal">
          <button className="modal-close" onClick={handleClose}>
            ×
          </button>
          <button className="modal-arrow prev" onClick={handlePrevLarge}>
            ◀
          </button>
          <img
            src={getImageUrl(images[selectedImage])}
            alt={images[selectedImage].altText || images[selectedImage].image?.filename || 'Large Image'} // Usa altText
            className="modal-image"
          />
          <button className="modal-arrow next" onClick={handleNextLarge}>
            ▶
          </button>
        </div>
      )}
    </div>
  );
};

export default PhotoGalleryView;